import React, { FC } from 'react'
import { CheckWithElement, ListWithImg } from 'Pages/landings/newLandings/common/components'
import forOutletWebp from './forOutlet.webp'
import forOutletJpg from './forOutlet.jpg'
import { Title, Subtitle, Text, TextSemibold, Footnote } from './styled'

export const ForOutletComponent: FC = () => (
	<ListWithImg imgWebp={forOutletWebp} imgJpg={forOutletJpg}>
		<Title>Для торговой точки</Title>
		<Subtitle>Подходит для магазинов, ресторанов, фитнес-клубов и парикмахерских</Subtitle>
		<CheckWithElement
			text={() => (
				<Text>
					{' '}
					<TextSemibold>От 1,3 %</TextSemibold> — комиссия с оборота
				</Text>
			)}
		/>
		<CheckWithElement
			text={() => (
				<Text>
					{' '}
					<TextSemibold>1-3 дня</TextSemibold> — срок подключения
				</Text>
			)}
		/>
		<CheckWithElement
			text={() => (
				<Text>
					{' '}
					<TextSemibold>0 ₽*</TextSemibold> — стоимость терминала
				</Text>
			)}
		/>
		<Footnote>*Сервисной платы нет при обороте от 80 тысяч ₽/мес. на терминал</Footnote>
	</ListWithImg>
)
